import React from 'react';
import { motion } from 'framer-motion';
import { EASE_SMOOTH, DURATION_NORMAL } from '../../utils/motionPresets';

function ChartCard({ title, icon: Icon, children, footer, className = '', delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: DURATION_NORMAL, delay, ease: EASE_SMOOTH }}
      className={`chart-card min-w-0 ${className}`}
    >
      {title ? (
        <div className="chart-card-header">
          {Icon ? <Icon className="chart-card-icon" strokeWidth={1.75} /> : null}
          <h3 className="chart-card-title min-w-0 truncate">{title}</h3>
        </div>
      ) : null}
      <div className="chart-card-body">{children}</div>
      {footer ? <div className="chart-card-footer">{footer}</div> : null}
    </motion.div>
  );
}

export default ChartCard;
